import React from 'react';

type Props = {
  size: number;
  children: React.ReactNode;
};

const Indent = ({ size, children }: Props) => {
  return <div style={{ marginLeft: size }}>{children}</div>;
};

export default Indent;
